import { type ChangeEvent, type FC, useCallback } from 'react';

import classNames from 'classnames';

import type { ColorOptionType } from '../../../../constants/data';
import { ui } from '../../../../utils/helpers';
import type { FormFieldEvent } from '../../types';

import styles from './color_option.module.css';

export type ValueType = string;

export type ColorOptionProps = {
  className?: string;
  options?: ColorOptionType[];
  value?: ValueType;
  onChange?: (value: ValueType, event?: FormFieldEvent) => void;
  disabled?: boolean;
  name?: string;
  // If true, allows to deselect the color
  deselect?: boolean;
};

const ColorOption: FC<ColorOptionProps> = (props) => {
  const { value, deselect = true, onChange, className, options = [] } = props;

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { target } = event;
      if (target.checked) {
        onChange?.(target.value, event);
      } else if (deselect) {
        onChange?.('', event);
      } else {
        onChange?.(target.value, event);
      }
    },
    [onChange, deselect],
  );

  return (
    <div
      className={classNames(styles.root, className)}
      aria-label="Color selector"
    >
      {options.map((option) => {
        const colorKey = option.value.toLowerCase().replace('#', '');
        return (
          <label
            className={classNames(styles.label)}
            key={colorKey}
            {...ui(`color-option-${colorKey}`)}
          >
            <input
              disabled={props.disabled}
              name={props.name}
              type="checkbox"
              value={option.value}
              className={styles.control}
              checked={value === option.value}
              onChange={handleChange}
              aria-label={`Select ${option.label}`}
              style={{ backgroundColor: option.value }}
            />
          </label>
        );
      })}
    </div>
  );
};

export default ColorOption;
